/**
 * @Description APP
 * @Author 
 * @Time 
 */
/* HTML */
<template>
     <div id="app" > 
	<!--<div id="app"
	:style="{'transform':`scale(${scalesNum}) translate(0,0)`,
    '-webkit-transform':`scale(${scalesNum}) translate(0,0)`,
    '-moz-transform':`scale(${scalesNum}) translate(0,0)`,
    '-o-transform':`scale(${scalesNum}) translate(0,0)`,
    '-ms-transform':`scale(${scalesNum}) translate(0,0)`
	}">-->
		<router-view>
			<login />
		</router-view>
		<!-- footer start -->
		<!--<div class="footer" >Copyright &copy; 北京金坤科创技术有限公司 提供技术支持</div>-->
		<!--<div class="footer" ></div>-->
		<!-- footer end -->
	</div>
</template>

/* JS */
<script>
	//import Login from "./views/Login";
	//import ManagerApp from "./views/ManagerApp";
	
	export default {
		data () {
			return {
				scalesNum: 1 // 缩放比例
			}
		},
		mounted () {
			// 计算缩放比例

			this.resize_window()

			window.addEventListener('resize', () => {
			this.resize_window()

			})

		},
		methods: {
			resize_window() {// 因为设计图是带1920*1080的，但是浏览器本身带顶部工具栏，所以缩放到时候稍微更小一点，这样不会有滚动条，这个值可以选择更大些，比如2300，这样左右两边会有空白
				var ele = document.getElementById("app");
				let myWidth = document.documentElement.clientWidth;
				let myHeight = document.documentElement.clientHeight;
				// let myWidth = document.body.clientWidth;
				// let myHeight = document.body.clientHeight;
				if( myHeight / 1920 !== 0 && (( myWidth / 1920) / (myHeight / 1080) <= 1)){
					console.log()
					this.scalesNum = myHeight / 1080;
				}else{
					this.scalesNum = myWidth / 1920;
				}
				if( (( myWidth / 1920) / (myHeight / 1080) > 1)){
					console.log()
					this.scalesNum = myWidth / 1920;
				}else{
					this.scalesNum = myHeight / 1080;
				}
			}
		},

		/**
		 * @Description 组件名
		 * @Author 
		 * @Time 
		 */
		name: 'App',
		/**
		 * @Description 组件注册
		 * @Author 
		 * @Time 
		 */
		//components: {Login, ManagerApp}
	}
</script>

/* CSS */
<style lang="scss" scoped>
	#app{
		margin: 0;
		padding: 0;
		transform-origin: 0 0;
		position:absolute;
		/*width: 1920px;
		height: 1080px;*/
		/*width: 2150px;
		height: 1000px;*/
		/*left:50%;*/
		overflow: hidden;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue